/* eslint-disable react-hooks/exhaustive-deps */
import { Path } from "@common/constans";
import { IGResponse } from "@common/models";
import { ISurveyAnswerOption } from "@common/models/CMS/SurveyAnswerOption";
import { ISurveyForm } from "@common/models/CMS/SurveyForm";
import { ISurveyGroup } from "@common/models/CMS/SurveyGroup";
import { ISurveyConfirm } from "@common/models/SurveyConfirm";
import Alert from "@components/general/Alert";
import Button from "@components/general/form/Button";
import Loading from "@components/general/Loading";
import { IViewport } from "@config/appConfig";
import { IAppState } from "@misc/State";
import { SurveyGroup } from "@pages/survey";
import Config from "@service/Config";
import { useApolloQuery } from "@service/graphql";
import { SURVEY } from "@service/graphql/query/Query.Survey";
import Notification from "@service/Notification";
import { Action, participateSurvey } from "@service/proxy";
import Translate from "@service/Translate";
import { FC, useContext } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Route } from "./Route";
import { ParticipateAction, ParticipateContext } from "./index";

export const Questionnaire: FC = () => {

    const { tr } = Translate;
    const { push } = useHistory();
    const { medium } = Config.get<IViewport>("viewport");
    const { width } = useSelector((state: IAppState) => ({ width: state.windowWidth }));
    const { data, loading, error } = useApolloQuery<IGResponse<ISurveyForm[]>>(SURVEY);
    const { participate, participateDispatch } = useContext(ParticipateContext);

    const renderSurveyForm = () => {
        let content;
        if (data?.surveyForm && data?.surveyForm[0]) {
            const surveyForm = data.surveyForm[0];
            let renderItems: ISurveyGroup[] = [];
            for (let i = 0, totalItems = surveyForm.bag?.contentItems.length; i < totalItems; i++) {
                if (renderItems.length && (renderItems[0].colspan !== surveyForm.bag.contentItems[i].colspan || i + 1 === totalItems)) {
                    if (i + 1 === totalItems)
                        renderItems.push(surveyForm.bag.contentItems[i]);
                    if (renderItems[0].colspan === surveyForm.columnCount)
                        content = <>{content}{renderItems.map((x, index) => <SurveyGroup
                            key={index}
                            surveyGroup={x}
                            singleAnswers={(participate.surveys && participate.surveys[0].singleAnswers) || []}
                            multiAnswers={(participate.surveys && participate.surveys[0].multiAnswers) || []}
                            onChangeMultiAnswer={onChangeMultiAnswer}
                            onChangeSingleAnswer={onChangeSingleAnswer}
                        />)}</>;
                    else
                        content = <>{content}<div style={{ height: width > medium ? surveyForm.fixedHeight : "auto" }} className="survey-group-container row flex flex-wrap column-direction">
                            {
                                renderItems.map((x, index) => <div key={index} className={`${surveyForm.columnCount ? `col-1-${surveyForm.columnCount} col-md-1-1 col-sm-1-1` : ""}`}>
                                    <SurveyGroup
                                        surveyGroup={x}
                                        singleAnswers={(participate.surveys && participate.surveys[0].singleAnswers) || []}
                                        multiAnswers={(participate.surveys && participate.surveys[0].multiAnswers) || []}
                                        onChangeMultiAnswer={onChangeMultiAnswer}
                                        onChangeSingleAnswer={onChangeSingleAnswer}
                                    />
                                </div>
                                )
                            }
                        </div>
                        </>;
                    renderItems = [];
                }
                renderItems.push(surveyForm.bag.contentItems[i])
            }
        }
        return content;

        function onChangeMultiAnswer(questionId: number, answer: ISurveyAnswerOption) {
            // Create multi answers for first initiate
            const survey: ISurveyConfirm = (participate.surveys && participate.surveys[0]) || {};
            if (!survey.multiAnswers)
                survey.multiAnswers = [];
            let findQuestion = survey.multiAnswers?.find(q => q.questionId === questionId);
            // Create question
            if (!findQuestion) {
                survey.multiAnswers?.push({ questionId: questionId, answerIds: [] })
                findQuestion = survey.multiAnswers?.find(q => q.questionId === questionId);
            }
            // Push answer item into question
            if (!survey.multiAnswers?.find(question => question.answerIds.find(a => a === answer.id)))
                findQuestion?.answerIds.push(answer.id)
            else
                findQuestion?.answerIds.splice(findQuestion.answerIds.findIndex(a => a === answer.id), 1)
            // Remove question if has no answer item
            if (!findQuestion?.answerIds.length)
                survey.multiAnswers?.splice(survey.multiAnswers?.findIndex(q => q.questionId === questionId), 1);
            participateSurvey(Action.POST, { data: { ...survey, id: participate.id } })
                .then((response) => {
                })
                .catch((error) => {})
            participateDispatch({ type: ParticipateAction.Participate, payload: { surveys: [survey] } });
        }

        function onChangeSingleAnswer(questionId: number, answer: ISurveyAnswerOption) {
            const survey: ISurveyConfirm = (participate.surveys && participate.surveys[0]) || {};
            if (!survey.singleAnswers)
                survey.singleAnswers = [];
            const findQuestion = survey.singleAnswers?.find(x => x.questionId === questionId);
            if (findQuestion)
                findQuestion.answerId = answer.id;
            else
                survey.singleAnswers?.push({ questionId: questionId, answerId: answer.id });
            participateSurvey(Action.POST, { data: { ...survey, id: participate.id } })
                .then((response) => {

                })
                .catch((error) => {})
            participateDispatch({ type: ParticipateAction.Participate, payload: { surveys: participate.surveys?.slice() } });
        }
    }

    const onSubmitForm = () => {
        push(Path.FlightSurvey.Feedback);
        Notification.success(tr("feedback_submitted_msg"));
    }

    return (
        <div className="flight-survey-questionnaire">
            {
                error ? <Alert type="danger" variant="contain" title={tr("err_get_data")} />
                    : loading ?
                        <Loading showLoader={loading} />
                        :
                        <>
                            <Route />
                            <div className="questionnaire-section">
                                {renderSurveyForm()}
                                <div className="button-section flex">
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        height="40px"
                                        text={tr("btn_next")}
                                        // loading={showSubmitFormLoading}
                                        onClick={onSubmitForm}
                                    />
                                </div>
                            </div>
                        </>

            }
        </div>
    )
}